module.exports = "---\ntitle: \"1024 = 2^10\"\ntime: \"2024-10-24\"\n---\n\n祝全体程序员1024节快乐！！!\n";